/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctPercent, FctValue, FctValue27 } from '../../../../Fct/generics';
import { getAssetRateByApy } from '../../../../Fct/plugins/AaveV2/helpers/getAssetRateByApy';
import { supportedContracts } from '../../../../Fct/plugins/Validator/constants';
export var ApyLessThan = createPlugin({
    protocol: 'RADIANTV2',
    type: 'VALIDATOR',
    method: 'lessThan',
    description: 'Check if a value is less than a number',
    name: 'apyLessThan',
    supportedContracts: supportedContracts,
    onCreate: function (_a) {
        var chainId = _a.chainId, input = _a.input;
        input.rateValue.subscribe({
            callback: function (_a) {
                var value = _a.value;
                input.methodParams.value1.set({ value: value });
            },
            id: 'change_value1_on_rateValue_change',
        });
        input.methodParams.value1.set({ value: input.rateValue.value });
        var setValue2 = function (_a) {
            var value = _a.value;
            if (!value) {
                input.methodParams.value2.set({ value: undefined });
                return;
            }
            if (input.apyValue.isVariable) {
                console.error('should be real value');
                return;
            }
            var rate = getAssetRateByApy({ apy: value });
            input.methodParams.value2.set({ value: rate.rate });
        };
        input.apyValue.subscribe({
            callback: setValue2,
            id: 'change_value_on_apyValue_change',
        });
        setValue2({ value: input.apyValue.value });
    },
    getParams: function () { return ({
        input: {
            to: new FctAddress({}),
            rateValue: new FctValue27({ mode: 'VARIABLE' }),
            apyValue: new FctPercent({ destination: 'percent', mode: 'INPUT' }),
            methodParams: {
                value1: new FctValue({ readonly: true }),
                value2: new FctValue({ readonly: true }),
            },
        },
        output: {
            value: new FctValue({
                innerIndex: 0,
                description: 'Returns value1 subtraction from value2',
            }),
        },
    }); },
});
